import { GET_ALL_DC_LIST, SEARCHED_DC_LIST } from './actionTypes';

const initialState = {
    DCList: [],
    DCListErrorMessage: null,
    selectedDCList: []
}

const searchDCInputReducer = (state=initialState, action={type:''}) => {
    switch(action.type) {
        case GET_ALL_DC_LIST.SUCCESS:
            return {
                ...state, DCList: action.payload, DCListErrorMessage: null
            }
        case GET_ALL_DC_LIST.ERROR:
            return {
                ...state, DCList: [], DCListErrorMessage: action.payload
            }
        case SEARCHED_DC_LIST.SET:
            return {
                ...state, selectedDCList: action.payload
            }
        default:
            return {
                ...state
            }
    }
}

export default searchDCInputReducer;